import React from 'react';

import 'moment/locale/ru';

import { loc } from '../../lib/loc';
import { OrderLoc } from '../../loc/order';

import Loader from '../Loader';
import EmptyItem from './EmptyItem';
import Item from './Item';

const OrdersTable = ({ load, data }) => {
    return (
        <div className="table mb-30">
            {load ? (
                <Loader />
            ) : (
                <table>
                    <thead>
                        <tr>
                            <th>{loc(OrderLoc.table.number)}</th>
                            <th>{loc(OrderLoc.table.rentalDates)}</th>
                            <th>{loc(OrderLoc.table.rentEnd)}</th>
                            <th>{loc(OrderLoc.table.deliveryType)}</th>
                            <th>{loc(OrderLoc.table.status)}</th>
                            {/*<th className="text-center">{loc(OrderLoc.table.payment)}</th>*/}
                            {/*<th className="text-center">{loc(OrderLoc.table.documents)}</th>*/}
                            <th className="text-center">{loc(OrderLoc.table.amount)}</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>{data?.length === 0 ? <EmptyItem /> : data?.map((item, i) => <Item key={i} data={item} />)}</tbody>
                </table>
            )}
        </div>
    );
};

export default OrdersTable;
